import { Component, OnInit } from '@angular/core';
import { ActionStatusKpiDto } from '@model/kpi/action-status-kpi-dto';
import { DashboardService } from '@component/dashboard/services/dashboard.service';
import { GraphActionKpiComponent } from '@component/kpi/action/graph-action-kpi/graph-action-kpi.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCardModule } from 'ng-zorro-antd/card';
import { finalize } from 'rxjs/internal/operators/finalize';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzFlexModule } from "ng-zorro-antd/flex";

@Component({
  selector: 'app-dashboard-action-kpi',
  imports: [
    TranslateModule,
    GraphActionKpiComponent,
    NzSpinModule,
    NzCardModule,
    NzBadgeModule,
    NzFlexModule
  ],
  templateUrl: './dashboard-action-kpi.component.html',
  styleUrl: './dashboard-action-kpi.component.scss',
})
export class DashboardActionKpiComponent implements OnInit {
  /**
   * Loading state
   * @public
   * @type {boolean}
   */
  public isLoading: boolean = false;
  /**
   * Action KPI data
   *
   * @public
   * @type {ActionStatusKpiDto[]}
   */
  public actionKpi: ActionStatusKpiDto[] = [];
  /**
 * Total count of item
 *
 * @public
 * @type {number}
 */
  public totalCount: number = 0;



  constructor(
    private readonly _dashboardService: DashboardService
  ) { }
  ngOnInit(): void {
    this.isLoading = true;
    this._dashboardService.getActionStatusDashboard()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (data) => {
          this.actionKpi = [...data];
          this.getTotalActionCount();
        },
        error: () => {
        }
      });
  }

  /**
 * Calculate the total count of items
 */
  private getTotalActionCount(): void {
    this.totalCount = this.actionKpi?.reduce((sum, item) => sum + item.count, 0) ?? 0;
  }
}
